export const MinLength = 3;
export const MaxLength = 14;
export const DebounceTime = 300;
export const ControlName = '';
export const Label = 'Відділення або поштомат';
export const NothingFoundLabel = 'Нічого не знайдено';
export const Placeholder = 'Вкажіть цифрову адресу';
export const Classes = 'form-col form-col-8';
